import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ProductShot1 } from "./ProductShot1";
import { defaultData } from "./ProductShot1DefaultData";
import { meta } from "./ProductShot1Metadata";
import imagePreview from "./product_shot_1_preview.png";

export const ProductShot1Block: BlockExport = {
  type: "component",
  Block: ProductShot1,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
